<!-- Creates a link definition -->
<cc-template-links-modal-create
  *ngIf="status === linkStatus.Initial"
  [company]="company"
  [taskType]="type"
  [team]="team"
  [templates]="templates"
  (closeModal)="onCloseModal()"
  (newTaskCreated)="onNewTaskCreated($event)"
>
</cc-template-links-modal-create>

<!-- Updates a link definition -->
<cc-template-links-modal-update
  *ngIf="status === linkStatus.Edit || status === linkStatus.Unarchive"
  [company]="company"
  [taskType]="type"
  [team]="team"
  [templates]="templates"
  [taskDefinition]="taskDefinition"
  [unarchiveLink]="status === linkStatus.Unarchive"
  (closeModal)="onCloseModal()"
  (taskUpdated)="onNewTaskCreated($event)"
>
</cc-template-links-modal-update>

<!-- Link processed, some warnings generated -->
<cc-template-links-modal-completed-with-warnings
  *ngIf="status === linkStatus.CompletedWithWarnings"
  [warnings]="warnings"
  [taskCreationMode]="taskCreationMode"
  (closeModal)="onCloseModal()"
  (acknowledge)="onMoveToCompleted()"
>
</cc-template-links-modal-completed-with-warnings>

<!-- Completion screen -->
<cc-template-links-modal-completed
  *ngIf="status === linkStatus.Completed"
  [taskDefinition]="taskDefinition"
  [taskCreationMode]="taskCreationMode"
  [team]="team"
  [taskType]="type"
  (closeModal)="onCloseModal()"
  (downloadQrCodePoster)="onQrCodePosterDownload()"
  (copyLink)="onLinkCopied()"
>
</cc-template-links-modal-completed>
